import ActionColumn from './ActionColumn'

export default ActionColumn
